import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { useNotification } from 'utils';
import { Modal } from '../components';
export const ModalTest = () => {
    const { liveNotification } = useNotification();
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const handleAction = () => {
        setShow(false);
        liveNotification('success', 'action triggered');
    };
    return (_jsxs(Card, Object.assign({ className: 'p-3 w-100' }, { children: [_jsx(Row, { children: _jsx(Col, { children: _jsx(Button, Object.assign({ onClick: () => setShow(true), variant: 'primary' }, { children: "Show modal" })) }) }), _jsx(Modal, { title: 'Confiramtion Modal', message: 'Do you confirm this action?', show: show, onClose: handleClose, onAction: handleAction })] })));
};
